// services/authService.js - Enhanced with login functionality
const API_BASE_URL = 'https://growthsprouts-server.vercel.app/api';

export const authService = {
  async createFamily(familyData, guardianData) {
    try {
      console.log('🚀 Frontend: Making request with data:', {
        familyData,
        guardianData: { ...guardianData, password: '[HIDDEN]', confirmPassword: '[HIDDEN]' }
      });
      
      const requestBody = { familyData, guardianData };
      
      const response = await fetch(`${API_BASE_URL}/auth/create-family`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      console.log('📡 Frontend: Response status:', response.status);

      if (!response.ok) {
        const errorData = await response.json();
        console.error('❌ Frontend: Server error response:', errorData);
        throw new Error(errorData.error || `Server error: ${response.status}`);
      }

      const result = await response.json();
      console.log('✅ Frontend: Success response:', result);

      return result;
    } catch (error) {
      console.error('❌ Frontend: Request failed:', error);
      throw error;
    }
  },



  async checkFamilyName(familyName) {
    try {
      if (!familyName || familyName.trim().length < 2) {
        return {
          available: false,
          message: 'Family name must be at least 2 characters'
        };
      }

      console.log('🔍 Frontend: Checking family name:', familyName);
      
      const response = await fetch(`${API_BASE_URL}/auth/check-family-name/${encodeURIComponent(familyName.trim())}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`Server error: ${response.status}`);
      }

      const result = await response.json();
      console.log('🔍 Frontend: Family name check result:', result);

      return result;
    } catch (error) {
      console.error('❌ Frontend: Family name check failed:', error);
      return {
        available: false,
        message: 'Error checking family name'
      };
    }
  },

  async login(email, password) {
    try {
      console.log('🔐 Frontend: Attempting login for:', email);
      
      const requestBody = { email, password };
      
      const response = await fetch(`${API_BASE_URL}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      console.log('📡 Frontend: Login response status:', response.status);

      if (!response.ok) {
        const errorData = await response.json();
        console.error('❌ Frontend: Login error response:', errorData);
        throw new Error(errorData.error || 'Login failed');
      }

      const result = await response.json();
      console.log('✅ Frontend: Login successful:', { 
        ...result, 
        data: { 
          ...result.data, 
          guardian: { ...result.data.guardian, password_hash: '[HIDDEN]' } 
        } 
      });

      return result;
    } catch (error) {
      console.error('❌ Frontend: Login request failed:', error);
      throw error;
    }
  },



};